import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Card, CardBody, Container, Spinner, Table } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { campaignBadge, fmtDate, readError } from "../../helpers/whatsappTemplates";

// Campagnes WhatsApp : liste et actions rapides (pause, reprise, annulation).
export function CampaignsList() {
    const [list, setList] = useState(null);
    const [error, setError] = useState(null);

    const load = () => apiFetch(API.back + "/whatsapp-campaigns", { market: false })
        .then(async (res) => { if (!res.ok) throw new Error(await readError(res)); return res.json(); })
        .then(setList)
        .catch((e) => { setError("Campagnes indisponibles : " + e.message); setList([]); });
    useEffect(() => { load(); }, []);

    const act = async (id, action) => {
        if (action === "cancel" && !window.confirm("Annuler cette campagne ?")) return;
        const res = await apiFetch(API.back + "/whatsapp-campaign-action", { method: "POST", market: false, body: JSON.stringify({ id, action }) });
        if (!res.ok) { setError(await readError(res)); return; }
        load();
    };

    return (
        <Container fluid className="p-0">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h1 className="h3 mb-0">Campagnes WhatsApp</h1>
                <Link to="/whatsapp/campaign/new" className="btn btn-primary">+ Nouvelle campagne</Link>
            </div>
            {error && <Alert color="danger">{error}</Alert>}
            <Card>
                <CardBody className="p-0">
                    {!list ? <div className="p-3"><Spinner size="sm" /></div> : list.length === 0 ? <div className="p-3">Aucune campagne. <Link to="/whatsapp/campaign/new">Créer la première</Link>.</div> : (
                        <Table className="mb-0" hover responsive>
                            <thead><tr><th>Campagne</th><th>Template</th><th>Statut</th><th>Envoi</th><th>Envoyés</th><th>Au plafond</th><th>Échecs</th><th /></tr></thead>
                            <tbody>
                                {list.map((c) => {
                                    const b = campaignBadge(c.status);
                                    return (
                                        <tr key={c.id}>
                                            <td><Link to={`/whatsapp/campaign/${c.id}`}><b>{c.name}</b></Link>{c.failReason && <div className="small" style={{ color: "#a50e15" }}>{c.failReason}</div>}</td>
                                            <td>{c.templateName}</td>
                                            <td><span style={{ padding: "3px 9px", borderRadius: 999, fontSize: 12, fontWeight: 700, background: b.bg, color: b.color }}>{b.label}</span></td>
                                            <td>{fmtDate(c.scheduledAt)}</td>
                                            <td>{c.sent || 0}</td>
                                            <td>{c.skippedCap || 0}</td>
                                            <td>{c.failed || 0}</td>
                                            <td className="text-right text-nowrap">
                                                {c.status === "sending" && <Button size="sm" color="light" className="mr-1" onClick={() => act(c.id, "pause")}>Pause</Button>}
                                                {c.status === "paused" && <Button size="sm" color="light" className="mr-1" onClick={() => act(c.id, "resume")}>Reprendre</Button>}
                                                {c.status === "scheduled" && <Button size="sm" color="light" className="mr-1" onClick={() => act(c.id, "pause")}>Déprogrammer</Button>}
                                                {["draft", "scheduled", "paused"].includes(c.status) && <Button size="sm" color="link" className="text-danger mr-1" onClick={() => act(c.id, "cancel")}>Annuler</Button>}
                                                {["sending", "paused", "done", "failed", "cancelled"].includes(c.status) && <Link className="btn btn-sm btn-light" to={`/whatsapp/campaign/${c.id}/results`}>Résultats</Link>}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </CardBody>
            </Card>
        </Container>
    );
}
